// extracted by mini-css-extract-plugin
export default {"collapsed-tab":"collapsed-tab--HFh4Nvw6ES","collapsedTab":"collapsed-tab--HFh4Nvw6ES"};